import React, { useEffect, useRef, useState } from 'react';
import { DataGrid, Box, DropDownBox, DateBox, SelectBox, Button } from 'devextreme-react';
import { Item } from "devextreme-react/box";
import {
    Paging,
    Pager,
    FilterRow,
    Column,
    Export,
    SearchPanel,
    Grouping,
    Summary,
    TotalItem,
    GroupItem
} from 'devextreme-react/data-grid';

import { _path } from "../../../data/headerNavigation";
import { formatDate, resources } from '../../../data/app';
import { cellRender, cellRenderBold, formatToMoneyNumber, onCellPreparedSales, } from '../../../utils/common';


import http from '../../../utils/http';
import { dateByReport } from '../../../data/defaultObjects';
import { userService } from '../../../services/user.service';
import useAuthorization from '../../../hooks/useAuthorization';

const ResumenVentasPorDia = (props) => {

    const user = userService.getUser();

    const [areaId,] = useState(user.areaId);

    const [dateFrom, setDateFrom] = useState(dateByReport.from);
    const [dateTo, setDateTo] = useState(dateByReport.to);
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [_,] = useAuthorization(resources.verReporteDeVentas);
    //const [ options, setOptions ] = useState([]);

    let refData = useRef(null);


    const changeDateFrom = e => setDateFrom(e.value);

    const changeDateTo = e => setDateTo(e.value);

    const loadReport = () => {

        if (areaId > 0 && dateFrom && dateTo) {
            setLoading(true);
            http('reports/sales').asPost({ areaId, productId: null, from: dateFrom, to: dateTo, tipoFecha: 1, username: '' }).then(resp => {

                const data = resp;

                const groupedByDate = Object.values(
                    data.reduce((acc, curr) => {
                        const dateKey = curr.date.slice(0, 10);
                        const paymentTypeKey = curr.paymentType;
                        const key = `${dateKey}|${paymentTypeKey}`;

                        if (!acc[key]) {
                            acc[key] = {
                                date: dateKey,
                                paymentType: paymentTypeKey,
                                subTotalDetail: 0,
                                discountDetail: 0,
                                ivadetail: 0,
                                totalDetail: 0,
                                costoTotal: 0,
                                utilidades: 0
                            };
                        }
                        acc[key].subTotalDetail += curr.subTotalDetail;
                        acc[key].discountDetail += curr.discountDetail;
                        acc[key].ivadetail += curr.ivadetail;
                        acc[key].totalDetail += curr.totalDetail;
                        acc[key].costoTotal += curr.costoTotal;
                        acc[key].utilidades += curr.utilidades;
                        //acc[dateKey].utilidadesPorcentaje = ((acc[dateKey].utilidades / acc[dateKey].totalDetail) * 100).toFixed(2);

                        return acc;
                    }, {})
                );

                const dataWithUtilidades = groupedByDate.map(item => {
                    const utilidadesPorcentaje = item.totalDetail > 0 ? ((item.utilidades / item.totalDetail) * 100).toFixed(2) : 0;
                    return { ...item, utilidadesPorcentaje };
                });

                setData(dataWithUtilidades);

                setLoading(false);
            });
        }

    };

    const toMoney = data => formatToMoneyNumber(data.value);

    const title = 'Reporte de Ventas';

    const width = 140;

    return (
        <div className="">

            <Box direction="row" width="100%" height={75}>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Desde:</label>
                        <DateBox type="date"
                            value={dateFrom}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={changeDateFrom} />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Hasta:</label>
                        <DateBox type="date"
                            value={dateTo}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={changeDateTo} />
                    </div>
                </Item>

                <Item ratio={4}>
                    <div style={{ paddingTop: '19px' }}>
                        <Button
                            width={120}
                            text={`${loading ? 'Buscando...' : 'Buscar'}`}
                            type="default"
                            icon="search"
                            stylingMode="contained"
                            className="m-1"
                            disabled={loading}
                            onClick={loadReport}
                        />
                    </div>
                </Item>
            </Box>
            <Box direction="row" width="100%" height={75}>

                <Item ratio={1}>
                    <DataGrid
                        id="gridContainer"
                        ref={refData}
                        //keyExpr="date"
                        selection={{ mode: 'single' }}
                        dataSource={data}
                        showBorders={true}
                        showRowLines={true}
                        hoverStateEnabled={true}
                        onCellPrepared={onCellPreparedSales}
                    >
                        <SearchPanel visible={true} width={200} />
                        <Grouping autoExpandAll={true} />
                        <Paging defaultPageSize={10} />
                        <Pager
                            showInfo={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 50, 100, 500]}
                        />
                        <Export enabled={true} fileName={title} allowExportSelectedData={true} />

                        <Column dataField="paymentType" caption={'Tipo Pago'} grouped={true} format={formatDate} width={130} />
                        <Column dataField="date" dataType="date" caption="Fecha" format={formatDate} width={width} />
                        <Column dataField="subTotalDetail" caption="Sub Total" cellRender={cellRender()} width={width} />
                        <Column dataField="discountDetail" caption="Descuento" cellRender={cellRender()} width={width} />
                        <Column dataField="ivadetail" caption="IVA" cellRender={cellRender()} width={width} />
                        <Column dataField="totalDetail" caption="Total" cellRender={cellRender()} width={width} />
                        <Column dataField="costoTotal" caption="Costo Total" cellRender={cellRender()} width={width} />
                        <Column dataField="utilidades" caption="Utilidades" cellRender={cellRender()} width={width} />
                        <Column dataField="utilidadesPorcentaje" alignment={'right'} caption="% Utilidades" width={width} customizeText={(data) => `${data.value} %`} />

                        <Summary>
                            <GroupItem column="subTotalDetail" summaryType="sum" showInGroupFooter={true} customizeText={toMoney} />
                            <GroupItem column="discountDetail" summaryType="sum" showInGroupFooter={true} customizeText={toMoney} />
                            <GroupItem column="ivadetail" summaryType="sum" showInGroupFooter={true} customizeText={toMoney} />
                            <GroupItem column="totalDetail" summaryType="sum" showInGroupFooter={true} customizeText={toMoney} />
                            <GroupItem column="costoTotal" summaryType="sum" showInGroupFooter={true} customizeText={toMoney} />
                            <GroupItem column="utilidades" summaryType="sum" showInGroupFooter={true} customizeText={toMoney} />
                            <GroupItem column="utilidadesPorcentaje" summaryType="avg" showInGroupFooter={true} customizeText={(data) => `${toMoney(data)} %`} />
                            <TotalItem column="date" summaryType="sum" customizeText={() => 'Totales :'} />
                            <TotalItem column="subTotalDetail" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="discountDetail" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="ivadetail" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="totalDetail" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="costoTotal" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="utilidades" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="utilidadesPorcentaje" summaryType="avg" customizeText={(data) => `${toMoney(data)} %`} />

                        </Summary>
                    </DataGrid>
                </Item>
            </Box>
        </div>
    );
}



export default ResumenVentasPorDia;
